import { faqData } from "../../data";

export default {
    name: 'faqLinksSection',
    title: 'FAQ Navigation Links Section',
    type: 'document',
    fields: [
        {
            name: 'faqLinks',
            title: 'FAQ Navigation Links',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        { name: 'id', title: 'ID', type: 'string', validation: Rule => Rule.required() },
                        { name: 'name', title: 'Name', type: 'string', validation: Rule => Rule.required() }
                    ]
                }
            ],
            validation: Rule => Rule.required().min(1),
            initialValue: faqData.faqLinks
        }
    ],
    preview: {
        prepare() {
            return {
                title: 'FAQ Navigation Links Section',
                subtitle: 'FAQ Navigation Links Section'
            }
        }
    }
} 